<div class="json-viewer h-full w-full overflow-auto">
  <header>
    <div class="title">🔎 USDM JSON Subset Viewer</div>
    <label class="btn">📂 Open JSON<input id="file" type="file" accept=".json,.jsonl,application/json" hidden /></label>
    <div class="tabs">
      <div class="tab active" data-tab="treeTab">Tree</div>
      <div class="tab" data-tab="mindTab">Mind-map</div>
    </div>
    <button class="btn" id="reset">Reset to full</button>
  </header>

  <div class="layout">
    <aside>
      <div class="section">Filter key study objects</div>
      <div class="side-controls">
        <div class="hint">1. Search for specific keys:</div>
        <div class="ctrl"><input id="keyFilter" type="text" placeholder="Filter by key (e.g., arms)" /><button
            class="btn" id="applyKey">Apply</button></div>
        <div class="hint">2. Or click common study elements:</div>
      </div>
      <div class="side-controls">
        <div class="pill common" data-key="arms">arms</div>
        <div class="pill common" data-key="studyDesigns">studyDesigns</div>
        <div class="pill common" data-key="epochs">epochs</div>
        <div class="pill common" data-key="encounters">encounters</div>
        <div class="pill common" data-key="activities">activities</div>
        <div class="pill common" data-key="elements">elements</div>
        <div class="pill common" data-key="endpoints">endpoints</div>
        <div class="pill common" data-key="biomedicalConcepts">biomedicalConcepts</div>
        <div class="pill common" data-key="eligibilityCriteria">eligibilityCriteria</div>
        <div class="pill common" data-key="objectives">objectives</div>
      </div>
      <div class="section">Mind-map view</div>
      <div class="side-controls">
        <div class="hint">Choose what to show:</div>
        <div class="pill" id="nameDescOnly">📝 Names, Text & Descriptions</div>
        <div class="pill" id="showEverything">🔍 Show all fields</div>
      </div>
    </aside>

    <main>
      <div class="section">Viewer</div>

      <div id="treeTab" style="display:block; height:100%; display:flex; flex-direction:column;">
        <div id="tree" class="tree"></div>
      </div>

      <div id="mindTab" style="display:none; height:100%; flex-direction:column;">
        <div class="mindhint">Mind-map renders the <b>current dataset</b> (full JSON or your subset). Expand in tree and
          subset first if you want a smaller map.</div>
        <div class="legend"><span class="chip">Keys: blue</span><span class="chip">Values: green</span><span
            class="chip">Counts: purple</span></div>
        <div id="mindwrap"><svg id="mind" width="800" height="400"></svg></div>
      </div>
    </main>
  </div>
</div>